<template>
  <div>
    <div class="wrap" id="wrap" :class="{ 'yd-user-app': isUserApp }">
      <div class="body">
        <router-view v-slot="{ Component }">
          <header-bar />
          <!-- 상단 헤더바 -->
          <transition name="fade">
            <keep-alive :include="keepAlive">
              <component :is="Component" />
            </keep-alive>
          </transition>
          <!-- 하단 네비게이션바 -->
          <nav-bar />
          <store-bar />
        </router-view>
      </div>

      <teleport to="#wrap" v-if="isLoading || isForceLoading">
        <spinner />
      </teleport>
      <!-- 전체화면 modal component -->
      <teleport to="#wrap" v-for="(item, index) in modalComponents" :key="index">
        <component :index="index" :is="item.component" v-bind="item" @close="fnCloseModal" />
      </teleport>
      <!-- alert modal component -->
      <teleport to="#wrap" v-for="(item, index) in modalAlertComponents" :key="index">
        <component :index="index" :is="item.component" v-bind="item" @close="fnCloseModalAlert" />
      </teleport>
      <transition name="app-toast-fade">
        <div class="app-toast" v-if="appToast.isShow" role="status" aria-live="polite">
          {{ appToast.message }}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import HeaderBar from '@/components/common/layouts/TheHeader';
import NavBar from '@/components/common/layouts/TheNav';
import StoreBar from '@/components/common/layouts/TheStore';
import Spinner from '@/components/common/layouts/spinner/index';
import { computed, onBeforeUnmount, reactive, toRefs, watch } from 'vue';
import ProductIndex from '@/views/store/product/index';
import store from '@/store';
import { useRoute } from 'vue-router';

const layoutState = () => {
  const state = reactive({
    routeLayout: computed(() => store.getters['layout/getRouteLayout']),
    modalAlertComponents: computed(() => store.getters['layout/getModalAlertComponents'])
  });
  /** methods **/
  const fnCloseModalAlert = (index = 0) => {
    store.dispatch('layout/closeModalAlertComponent', { index });
  };
  const fnCloseModal = (index = 0) => {
    store.dispatch('layout/closeModalComponent', { index });
  };

  const isLoading = computed(() => store.getters['layout/getIsLoading']);
  const isForceLoading = computed(() => store.getters['layout/getIsForceLoading']);
  const modalComponents = computed(() => store.getters['layout/getModalComponents']);
  const appToast = computed(() => store.getters['layout/getToast']);
  return {
    fnCloseModalAlert,
    fnCloseModal,
    ...toRefs(state),
    modalComponents,
    appToast,
    isLoading,
    isForceLoading
  };
};

export default {
  name: 'wrap-index',
  components: { HeaderBar, NavBar, StoreBar, Spinner, ProductIndex },
  setup() {
    const route = useRoute();
    const isUserApp = computed(
      () => !route.matched.some((record) => String(record.name ?? '').startsWith('Admin'))
    );
    const keepAlive = computed(() => store.getters['layout/keepAliveList']);
    const key = computed(() => `${store.getters['layout/keepAliveList']?.length > 0 ?? false}`);
    let toastTimer = null;

    watch(
      () => store.getters['layout/getToast'],
      (toast) => {
        if (toastTimer) clearTimeout(toastTimer);
        if (!toast?.isShow) return;

        toastTimer = setTimeout(() => {
          store.commit('layout/hideToast');
        }, toast.duration ?? 1500);
      }
    );

    onBeforeUnmount(() => {
      if (toastTimer) clearTimeout(toastTimer);
    });

    // const dynamicLinkPath = computed(() => store.getters['dynamiclink/getPath']);
    // const fnPushDynamicLink = (path) => {
    //   console.log('fnPushDynamicLink 실행 :: ', path);
    //   setTimeout(async () => {
    //     if (path) {
    //       await router.push(path);
    //       store.commit('dynamiclink/setPath', '');
    //     }
    //   }, 500);
    // };
    //
    // watchEffect(() => fnPushDynamicLink(dynamicLinkPath.value));

    return {
      ...layoutState(),
      isUserApp,
      keepAlive,
      key
    };
  }
};
</script>

<style lang="scss">
.fade-enter-active {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
  transition: opacity 0.3s;
}
.body {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.app-toast {
  position: fixed;
  left: 50%;
  bottom: 92px;
  z-index: 1100;
  max-width: calc(100vw - 32px);
  padding: 10px 14px;
  border-radius: 6px;
  background: rgba(18, 18, 18, 0.9);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  pointer-events: none;
  text-align: center;
  transform: translate(-50%, 0);
  white-space: nowrap;
}

.app-toast-fade-enter-active,
.app-toast-fade-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.app-toast-fade-enter-from,
.app-toast-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, 8px);
}

@media (max-width: 360px) {
  .app-toast {
    white-space: normal;
  }
}
</style>
